<template>
    <router-link :to="to" class="link" :class="{ active: isActive }" @click="handleClick">
      <i v-if="icon" class="icon h5" :class="icon" />
      <transition name="fade" class="fw-bold">
        <span v-if="!collapsed"><slot /></span>
      </transition>
    </router-link>
</template>

<style src="./SidebarLink.scss" lang="scss" />
<script src="./SidebarLink.js"></script>
